import { CloseCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import classNames from 'classnames';
import type { ReactNode } from 'react';

import styles from './CalendarHeader.module.scss';

type Props = {
  label: ReactNode;
  statusLabel?: string;
};

export const CalendarHeader = ({ label, statusLabel }: Props) => {
  const closed = statusLabel !== undefined;

  if (closed) {
    return (
      <Tooltip title={statusLabel}>
        <div className={classNames(styles.header, { [styles.closed]: closed })}>
          <span>{label}</span>
          <CloseCircleOutlined className={styles.closedIcon} />
        </div>
      </Tooltip>
    );
  }

  return (
    <div className={classNames(styles.header)}>
      <span>{label}</span>
    </div>
  );
};
